module.exports = __webpack_public_path__ + "resources/img/img-security-securegate-icon-2.bb6e1178b5c2581809e7ed8452a8053a.png";